/**
 * 🟥 CUADRO NEGRO Beneficios Premium Oficiales (feb-2026).
 *
 * Fuente única de verdad de los beneficios del Plan Premium.
 *
 * Reglas estrictas:
 *   - El orden NO se altera.
 *   - Los textos NO se reescriben ni se traducen.
 *   - NO se agregan ni se quitan elementos sin un cuadro negro nuevo.
 *
 * Cualquier UI que muestre los beneficios Premium debe importar y
 * renderizar directamente desde aquí — sin duplicar literales.
 */

export const PREMIUM_BENEFITS = [
  "Chat ilimitado con Lyon-IA",
  "Imágenes ilimitadas (Quick Actions)",
  "Créditos ilimitados",
  "Style Packs y recetas exclusivas",
  "Acciones avanzadas del Builder",
  "Acciones automáticas del Builder",
  "Importación de recetas IA",
  "Modificaciones avanzadas",
  "Inferencia de estilos y análisis inteligente",
  "Acceso prioritario a nuevas funciones",
  "Uso completo del sistema sin restricciones",
];

export default PREMIUM_BENEFITS;
